import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { getUserAuth } from "../../recoil/selectors";
import { isProviderUniversalLogoutInProgress } from "../../auth/providerUniversalLogin";
import {
  LOGIN_PAGE_URL,
  MYPROFILE_URL,
  REQUISITION_URL,
} from "../urlConstants";
import { getCookieAccessToken } from "../requestUtils";

export const useLoginScreen = (): void => {
  const auth = useRecoilValue(getUserAuth);
  const history = useHistory();
  const { pathname, search } = useLocation();

  useEffect(() => {
    const currentPath = `${pathname}${search}`;
    const hasProviderAuth = Boolean(auth);
    const isRequisitionRoute = pathname.startsWith(REQUISITION_URL);
    const isProfileRouteWithSessionCookie =
      pathname.startsWith(MYPROFILE_URL) && Boolean(getCookieAccessToken());
    const shouldPreservePathWithoutHydratedAuth =
      isRequisitionRoute || isProfileRouteWithSessionCookie;
    const shouldPreserveCurrentPath =
      hasProviderAuth || shouldPreservePathWithoutHydratedAuth;

    if (shouldPreserveCurrentPath) {
      sessionStorage.setItem("current-pathname", currentPath);
    }

    if (isProviderUniversalLogoutInProgress()) {
      return;
    }

    if (!hasProviderAuth) {
      history.push(LOGIN_PAGE_URL);
    }
  }, [auth, history, pathname, search]);
};
